import { render, staticRenderFns } from "./OrderItemLocation.vue?vue&type=template&id=9c37c3d6&scoped=true"
import script from "./OrderItemLocation.vue?vue&type=script&lang=js"
export * from "./OrderItemLocation.vue?vue&type=script&lang=js"
import style0 from "./OrderItemLocation.vue?vue&type=style&index=0&id=9c37c3d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c37c3d6",
  null
  
)

export default component.exports